import React from 'react';
import { colors } from '@styleseat/brand';

type SymbolsAppleIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SymbolsAppleIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: SymbolsAppleIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.56251 3.75006C9.42826 3.75006 9.29701 3.70206 9.19351 3.61206C9.05738 3.49356 8.98576 3.31656 9.00226 3.13618C9.00676 3.09006 9.11588 1.99431 9.97463 1.11793C10.7824 0.292932 11.5688 0.0476821 11.6554 0.0221821C11.8388 -0.0310679 12.0368 0.0124321 12.1808 0.137682C12.3251 0.262557 12.396 0.452307 12.3694 0.641682C12.3566 0.732057 12.2235 1.55518 11.5324 2.47881C10.7925 3.46731 9.73576 3.72456 9.69113 3.73506C9.64838 3.74518 9.60526 3.75006 9.56251 3.75006Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1875 16.5C11.5207 16.5 11.0621 16.2836 10.6575 16.0928C10.2675 15.909 9.93037 15.75 9.375 15.75C8.81962 15.75 8.4825 15.909 8.0925 16.0928C7.68787 16.2836 7.22925 16.5 6.5625 16.5C4.94025 16.5 2.25 12.7766 2.25 8.8125C2.25 6.18375 4.062 4.125 6.375 4.125C7.13512 4.125 7.59712 4.34288 8.00475 4.53488C8.39175 4.7175 8.72625 4.875 9.375 4.875C10.0237 4.875 10.3582 4.7175 10.7452 4.53488C11.1529 4.34288 11.6149 4.125 12.375 4.125C13.374 4.125 14.2624 4.49325 15.0157 5.22037C15.1425 5.34262 15.2047 5.51775 15.1834 5.69288C15.162 5.868 15.06 6.02288 14.9077 6.11138C14.0392 6.6165 13.5 7.68713 13.5 8.90625C13.5 10.2791 14.2515 11.4596 15.3697 11.8429C15.5164 11.8931 15.6356 12.0015 15.6994 12.1425C15.7635 12.2831 15.7669 12.4444 15.708 12.588C14.7979 14.8181 13.284 16.5 12.1875 16.5Z"
      fill={color}
    />
  </svg>
);
